import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { sendDataWithPut } from "../../../services/services";
import FormDialog from "../../FormDialog";
import { showSuccessMsg } from "../../../utils/toast";

const EditDialog = ({ data = {}, cb, onClose }) => {
  return (
    <Formik
      initialValues={{
        acquirer_bin: data.acquirer_bin,
        acquirer_merchant_id: data.acquirer_merchant_id,
      }}
      validationSchema={Yup.object().shape({
        acquirer_bin: Yup.string().required("Acquirer BIN is required"),
        acquirer_merchant_id: Yup.string().required(
          "Acquirer Merchant ID is required"
        ),
      })}
      onSubmit={async (values, { setSubmitting }) => {
        const url = `/mpi_details/${data.id}/update/`;
        await sendDataWithPut(url, values, null, () => {
          showSuccessMsg();
          cb();
          onClose();
        });
        setSubmitting(false);
      }}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
        } = props;
        return (
          <FormDialog
            open={true}
            onClose={onClose}
            title="Edit MPI"
            scroll="paper"
            handleSubmit={handleSubmit}
            loading={isSubmitting}
            maxWidth="xs"
          >
            <Form autoComplete="off" noValidate>
              <Box sx={{ m: 1 }}>
                <Box sx={{ py: 1 }}>
                  <Typography variant="subtitle1" sx={{ pb: 0.5 }}>
                    Acquirer BIN
                  </Typography>
                  <TextField
                    name="acquirer_bin"
                    size="small"
                    fullWidth
                    value={values.acquirer_bin}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.acquirer_bin && errors.acquirer_bin)}
                    helperText={touched.acquirer_bin && errors.acquirer_bin}
                    disabled={isSubmitting}
                  />
                </Box>

                <Box sx={{ py: 1 }}>
                  <Typography variant="subtitle1" sx={{ pb: 0.5 }}>
                    Acquirer Merchant ID
                  </Typography>
                  <TextField
                    name="acquirer_merchant_id"
                    size="small"
                    fullWidth
                    value={values.acquirer_merchant_id}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(
                      touched.acquirer_merchant_id &&
                        errors.acquirer_merchant_id
                    )}
                    helperText={
                      touched.acquirer_merchant_id &&
                      errors.acquirer_merchant_id
                    }
                    disabled={isSubmitting}
                  />
                </Box>
              </Box>
            </Form>
          </FormDialog>
        );
      }}
    </Formik>
  );
};

export default EditDialog;
